import {
  version
} from '@/utils/version'

const domain = 'mfe88.com'

const protocol = 'https'

const env = environment()

function environment() {
  // return process.env.ENV
  const d = document.domain
  let e
  if (d.startsWith('localhost')) {
    e = 'local'
  } else if (d.startsWith('dev-')) {
    e = 'dev'
  } else if (d.startsWith('pet-')) {
    e = 'pet'
  } else if (d.startsWith('test-')) {
    e = 'test'
  } else if (d.startsWith('st-')) {
    e = 'st'
  } else {
    e = 'prod'
  }
  return e
}

const paasUrl = platformUrl('paas')
const saasUrl = platformUrl('saas')
const apiUrl = platformUrl('api')
const oauth2Url = platformUrl('oauth2')
const userUrl = platformUrl('user')
const operatorUrl = platformUrl('operator')
const providerUrl = platformUrl('provider')
const customerUrl = platformUrl('customer')
const merchantUrl = platformUrl('merchant')

function platformUrl(platform) {
  const platformDomain = platform + '.' + domain
  let platformHost
  switch (env) {
    case 'local':
      platformHost = 'dev-' + platformDomain
      break
    case 'dev':
      platformHost = 'dev-' + platformDomain
      break
    case 'pet':
      platformHost = 'pet-' + platformDomain
      break
    case 'test':
      platformHost = 'test-' + platformDomain
      break
    case 'st':
      platformHost = 'st-' + platformDomain
      break
    case 'prod':
      platformHost = '' + platformDomain
      break
    default:
      platformHost = '' + platformDomain
      break
  }
  return protocol + '://' + platformHost
}

const mfe88 = {
  version,
  domain,
  protocol,
  env,
  paasUrl,
  saasUrl,
  apiUrl,
  oauth2Url,
  userUrl,
  operatorUrl,
  providerUrl,
  customerUrl,
  merchantUrl
}

export default mfe88
